import { render, staticRenderFns } from "./arviointilomake-aloituskeskustelu-readonly.vue?vue&type=template&id=15e64063&"
import script from "./arviointilomake-aloituskeskustelu-readonly.vue?vue&type=script&lang=ts&"
export * from "./arviointilomake-aloituskeskustelu-readonly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports